import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CONSTANTS } from '../../../constants/constants';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../../services/utils.service';
import { IconType } from '../../../types/misc';
import { passwordStrengthValidator } from '../../../modules/shared/validators/password.validator';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent implements OnInit, OnChanges {
  @Input() public fc: UntypedFormControl;
  @Input() public label: string;
  @Input() public hasPasswordValidation: boolean = false;
  @Input() public type:
    | 'time'
    | 'text'
    | 'email'
    | 'password'
    | 'datetime-local'
    | 'tel' = 'text';
  @Input() public focus: boolean = false;
  @Input() public note: string;
  @Input() public placeholder: string = '';
  @Input() public min: string = '';
  @Input() public disabled: boolean = false;
  @Input() public readonly: boolean = false;
  @Input() public icon: IconType | null = null;

  private subscriptions: Subscription = new Subscription();
  public id: string = UtilsService.getUniqueId();
  public showPassword: boolean = false;

  @Output() inputFocus: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() inputBlur: EventEmitter<Event> = new EventEmitter<Event>();

  @ViewChild('input') input: ElementRef;

  constructor(private cdr: ChangeDetectorRef) {}

  get isEmail(): boolean {
    return this.type === 'email';
  }

  get isPassword(): boolean {
    return this.type === 'password';
  }

  ngOnInit(): void {
    if (this.isEmail) {
      this.fc?.setValidators([
        Validators.required,
        Validators.pattern(CONSTANTS.REGEX.EMAIL),
      ]);
    }

    if (this.hasPasswordValidation) {
      this.fc?.setValidators([
        Validators.required,
        passwordStrengthValidator(),
      ]);
    }

    this.subscriptions.add(
      this.fc.valueChanges.subscribe(() => {
        this.cdr.detectChanges();
      })
    );
  }

  ngOnChanges({ disabled }: SimpleChanges): void {
    if (disabled) {
      if (disabled.currentValue) {
        this.fc?.disable();
      } else if (this.fc && this.fc.disabled) {
        this.fc?.enable();
      }
    }
  }

  getFormControlName(): string | null {
    return this.fc?.parent?.controls
      ? Object.keys(this.fc?.parent?.controls).find(
          (name) => this.fc === this.fc?.parent?.get(name)
        ) ?? null
      : null;
  }
}
